import { AqiStandardId, DatasourceId, MapSettingsDto, NetworkId, OpenSiteId } from '../types';
import { PreviewToken } from './data-preview';
import { ISettings } from './settings-interface';

export class DefaultSettings implements ISettings {
  constructor(
    private mapSettings: MapSettingsDto,
    private _networkId: NetworkId | null = null
  ) {}

  get networkId(): NetworkId | null {
    return this._networkId;
  }

  get datasourceId(): DatasourceId | null {
    return null;
  }

  get latitude(): number | null {
    return this.mapSettings.center[1];
  }

  get longitude(): number | null {
    return this.mapSettings.center[0];
  }

  get zoom(): number | null {
    return this.mapSettings.zoom;
  }

  get searchedLatitude(): number | null {
    return null;
  }

  get searchedLongitude(): number | null {
    return null;
  }

  get aqiStdId(): AqiStandardId | null {
    return null;
  }

  get preview(): PreviewToken | null {
    return null;
  }

  get openSiteId(): OpenSiteId | null {
    return null;
  }

  isEmpty(): boolean {
    return false;
  }
}
